import React, { Profiler } from 'react';

const withPerf = (Component) =>
  function RMPerf(props) {
    return (
      <Profiler onRender={() => {}}>
        <Component {...props} />
      </Profiler>
    );
  };

export default withPerf;
